export default __webpack_public_path__ + "static/media/normalEye.e9a4f8fc.png";